<script setup>
defineProps({
    size: {
        type: String,
        default: 'sidebar',
        validator: value => ['sidebar', 'phone'].includes(value),
    },
})
</script>

<template>
    <router-link
        :to="{ name: 'home' }"
        :class="['nav-wordmark', `nav-wordmark-${size}`]"
        aria-label="FRISKY home"
    >
        <!-- Raw <use>: BaseIcon only draws the square 16/20/24/32 grid; the wordmark is 179×30. -->
        <svg
            class="nav-wordmark-glyph"
            viewBox="0 0 179 30"
            aria-hidden="true"
        >
            <use href="#icon-logo-frisky-wordmark" />
        </svg>
    </router-link>
</template>

<style lang="scss" scoped>
@use '@design' as *;

.nav-wordmark {
    display: inline-flex;
    align-items: center;
    color: $c-text-primary;

    @include transition(filter);
    @include focusRing;

    // Wordmark hover = white bloom — the named T5 exception (design review 2026-09-09).
    // Pointer devices only: iOS keeps :hover after a tap, so the bloom would stick on phones.
    @media (hover: hover) {
        &:hover {
            filter: drop-shadow(0 0 6px $c-text-primary);
        }
    }
}

.nav-wordmark-sidebar .nav-wordmark-glyph {
    width: 179px;
    height: 30px;
}

.nav-wordmark-phone .nav-wordmark-glyph {
    width: 143px;
    height: 24px;
}
</style>
